var map = {
	"./ion-action-sheet.entry.js": [
		3305,
		3305
	],
	"./ion-alert.entry.js": [
		2386,
		2386
	],
	"./ion-app_8.entry.js": [
		4369,
		4369
	],
	"./ion-avatar_3.entry.js": [
		7422,
		7422
	],
	"./ion-back-button.entry.js": [
		4478,
		4478
	],
	"./ion-backdrop.entry.js": [
		3476,
		1065
	],
	"./ion-button_2.entry.js": [
		2127,
		2127
	],
	"./ion-card_5.entry.js": [
		3131,
		3131
	],
	"./ion-checkbox.entry.js": [
		4873,
		4873
	],
	"./ion-chip.entry.js": [
		4638,
		4638
	],
	"./ion-col_3.entry.js": [
		439,
		439
	],
	"./ion-datetime_3.entry.js": [
		9850,
		9850
	],
	"./ion-fab_3.entry.js": [
		7315,
		7315
	],
	"./ion-img.entry.js": [
		9295,
		9295
	],
	"./ion-infinite-scroll_2.entry.js": [
		9397,
		9397
	],
	"./ion-input.entry.js": [
		2346,
		2346
	],
	"./ion-item-option_3.entry.js": [
		9624,
		9624
	],
	"./ion-item_8.entry.js": [
		6893,
		6893
	],
	"./ion-loading.entry.js": [
		1730,
		1730
	],
	"./ion-menu_3.entry.js": [
		1985,
		1985
	],
	"./ion-modal.entry.js": [
		13,
		13
	],
	"./ion-nav_2.entry.js": [
		7220,
		7220
	],
	"./ion-popover.entry.js": [
		4634,
		4634
	],
	"./ion-progress-bar.entry.js": [
		6906,
		6906
	],
	"./ion-radio_2.entry.js": [
		4377,
		4377
	],
	"./ion-range.entry.js": [
		2682,
		2682
	],
	"./ion-refresher_2.entry.js": [
		5726,
		5726
	],
	"./ion-reorder_2.entry.js": [
		6106,
		6106
	],
	"./ion-ripple-effect.entry.js": [
		2937,
		2937
	],
	"./ion-route_4.entry.js": [
		6129,
		6129
	],
	"./ion-searchbar.entry.js": [
		3214,
		3214
	],
	"./ion-segment_2.entry.js": [
		3839,
		3839
	],
	"./ion-select_3.entry.js": [
		3733,
		3733
	],
	"./ion-slide_2.entry.js": [
		2992,
		2992
	],
	"./ion-spinner.entry.js": [
		6066,
		6066
	],
	"./ion-split-pane.entry.js": [
		9773,
		9773
	],
	"./ion-tab-bar_2.entry.js": [
		321,
		321
	],
	"./ion-tab_2.entry.js": [
		9678,
		9678
	],
	"./ion-text.entry.js": [
		1665,
		1665
	],
	"./ion-textarea.entry.js": [
		3482,
		3482
	],
	"./ion-toast.entry.js": [
		4662,
		4662
	],
	"./ion-toggle.entry.js": [
		3848,
		3848
	],
	"./ion-virtual-scroll.entry.js": [
		1192,
		1192
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 379;
module.exports = webpackAsyncContext;